export interface injectButtonToFooterLinksSectionParams {
    text: string
    onClick: string
}

export const INJECT_BUTTON_TO_FOOTER_LINKS_SECTION = 'inject button to footer links section';

export const injectButtonToFooterLinksSection = (params: injectButtonToFooterLinksSectionParams) => {
    const { text, onClick } = params;
    return {
        type: INJECT_BUTTON_TO_FOOTER_LINKS_SECTION,
        text,
        onClick,
    };
};
